module.exports={select:"Velg",selected:"Valgt"};